import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M9.62 15c0-2.828 0-4.243.878-5.121C11.377 9 12.79 9 15.619 9h1c2.829 0 4.243 0 5.122.879.878.878.878 2.293.878 5.121v1c0 2.828 0 4.243-.878 5.121-.88.879-2.293.879-5.122.879h-1c-2.828 0-4.242 0-5.121-.879-.879-.878-.879-2.293-.879-5.121z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M17.619 9c-.002-2.957-.047-4.489-.908-5.538a4 4 0 0 0-.554-.554C15.05 2 13.407 2 10.119 2c-3.287 0-4.931 0-6.037.908a4 4 0 0 0-.555.554C2.62 4.57 2.62 6.212 2.62 9.5c0 3.287 0 4.931.908 6.038a4 4 0 0 0 .555.554c1.048.86 2.58.906 5.537.908"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M18.62 15.5h-5m2.5-2.5v5"
    }, null, -1)
  ])))
}
export default { render: render }